<template>
    <v-app id="inspire">
        <v-navigation-drawer
                v-if="!notShowTemplate"
                v-model="drawer"
                app
                width="248"
                class="app-sidebar"
        >
            <navigation-menu></navigation-menu>
        </v-navigation-drawer>

        <v-app-bar
                v-if="$vuetify.breakpoint.smAndDown && !notShowTemplate"
                app
                dark
                class="app-mobile-bar"
        >
            <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
            <v-toolbar-title>SmartHome</v-toolbar-title>
        </v-app-bar>

        <v-content>
            <v-container
                    fluid
                    :class="{
                        'fill-height': notShowTemplate,
                        'not-show-template': notShowTemplate,
                    }"
                    class="container-custom"
            >
                <div
                        v-if="!notShowTemplate"
                        class="page-toolbar d-flex justify-space-between flex-wrap"
                >
                    <breadcrumbs></breadcrumbs>
                    <div class="top-nav">
<!--                        <v-btn icon>-->
<!--                            <v-icon>$account</v-icon>-->
<!--                        </v-btn>-->
                        <v-btn icon class="ml-2" @click="logout">
                            <v-icon>$logoutVariant</v-icon>
                        </v-btn>
                    </div>
                </div>
                <router-view></router-view>
            </v-container>
            <Footer
                    v-if="!notShowTemplate"
            ></Footer>
        </v-content>
        <v-snackbar
                v-if="error"
                :multi-line="true"
                :timeout="5000"
                color="error"
                @input="closeError()"
                :value="true"
        >
            {{ error }}
        </v-snackbar>
    </v-app>
</template>

<script>
    import Breadcrumbs from "./components/ui/Breadcrumbs";
    import Footer from "./components/block/Footer";
    import NavigationMenu from "./components/block/NavigationMenu";

    export default {
        components: {Breadcrumbs, Footer, NavigationMenu},
        props: {
            source: String
        },
        data: () => ({
            drawer: null,
            notShowTemplate: true,
            year: new Date().getFullYear()
        }),
        computed: {
            error() {
                return this.$store.getters.error;
            }
        },
        watch: {
            $route (){
                this.notShowTemplate = this.$route.name === 'login';
            }
        },
        methods: {
            closeError() {
                this.$store.dispatch('clearError')
            },
            logout() {
                this.$store.state.common.isLogin = false;
                this.$store.state.common.userId = null;

                localStorage.removeItem('is_login_'+process.env.VUE_APP_VERSION);
                localStorage.removeItem('user_id_'+process.env.VUE_APP_VERSION);

                this.$router.push({name: 'login'});
            }
        }
    }
</script>

<style lang="scss">
    .app-sidebar {
        background: linear-gradient(180deg, #17212b 0%, #101820 100%) !important;
        border-right: 0 !important;
        box-shadow: 12px 0 30px rgba(16, 24, 32, .08);
    }
    .app-mobile-bar {
        background: linear-gradient(135deg, #17212b 0%, #0f766e 100%) !important;
        box-shadow: 0 8px 24px rgba(15, 23, 42, .16) !important;
    }
    .container.container-custom {
        flex: 1 0 auto;
        display: block;
        width: 100%;
        max-width: 1600px;
        padding: 28px 34px 40px;
        margin: 0 auto;
    }
    .page-toolbar {
        min-height: 42px;
        margin-bottom: 18px;
        align-items: center;
    }
    .top-nav .v-btn {
        color: #64748b;
        background: #fff;
        border: 1px solid #e2e8f0;
        box-shadow: 0 4px 14px rgba(15, 23, 42, .05);
    }
    @media (max-width: 600px) {
        .container.container-custom {
            padding: 18px 14px 28px;
        }
        .page-toolbar {
            margin-bottom: 12px;
        }
    }
</style>
